import { combineReducers } from 'redux'
import trainingMatrix from './training_matrix'
import token from './token'
import user from './user'
import trainees from './trainees'
import tags from './tags'
import trainingModule from './training_module'
import v2tags from './v2_tags'
import v2TrainingModules from './v2_training_modules'
import trainingRequirements from './training_requirements'
import emailRecipients from './email_recipients'
import reset_password from './password/reset'
import change_password from './password/change'

const AngloTrainingRegister = combineReducers({
  trainingMatrix: trainingMatrix,
  token: token,
  user: user,
  trainees: trainees,
  tags: tags,
  trainingModule: trainingModule,
  v2tags: v2tags,
  v2TrainingModules: v2TrainingModules,
  trainingRequirements: trainingRequirements,
  emailRecipients: emailRecipients,
  reset_password,
  change_password,
})

export default AngloTrainingRegister



// WEBPACK FOOTER //
// ./src/reducers/index.js